import DateFnsUtils from '@date-io/date-fns';
import frLocale from 'date-fns/locale/fr';
import { MuiPickersUtilsProvider as MuiPickersUtilsProviderBase } from '@material-ui/pickers';
import React from 'react';

export const MuiPickersUtilsProvider = ({ children }: React.PropsWithChildren<any>) => {
    return (
        <MuiPickersUtilsProviderBase utils={DateFnsUtils} locale={frLocale}>
            {children}
        </MuiPickersUtilsProviderBase>
    );
};
